export const useMyTeamsEffectiveParams = (props: any, routeParams: any) => {
  return {
    effectiveLastPaidRank: props.lastPaidRank ?? routeParams.lastPaidRank ?? '',

    effectiveHighestAchievedRank:
      props.highestAchievedRank ?? routeParams.highestAchievedRank ?? '',

    effectiveCoachCurrentRank:
      props.coachCurrentRank ?? routeParams.coachCurrentRank ?? '',

    effectiveUserId: props.userId ?? routeParams.userId ?? '',
  };
};
